module.exports = __webpack_public_path__ + "static/pro4.png";